import PropTypes from "prop-types";
import clsx from "clsx";

/**
 * Section title component with customizable text, subtitle, and styling
 *
 * @component
 * @param {Object} props
 * @param {string} [props.titleText] - Main title text
 * @param {string} [props.subtitleText] - Subtitle text
 * @param {string} [props.subtitleColorClass] - CSS class for subtitle color
 * @param {string} [props.positionClass] - CSS class for position/alignment
 * @param {string} [props.spaceClass] - CSS class for spacing
 * @param {string} [props.borderClass] - CSS class for border styling
 */
const SectionTitle = ({ titleText, subtitleText, subtitleColorClass, positionClass, spaceClass, borderClass }) => {
  return (
    <div className={clsx("section-title", positionClass, spaceClass, borderClass)}>
      <h2>{titleText}</h2>
      <p className={clsx(subtitleColorClass)}>{subtitleText}</p>
    </div>
  );
};

SectionTitle.propTypes = {
  borderClass: PropTypes.string,
  positionClass: PropTypes.string,
  spaceClass: PropTypes.string,
  subtitleText: PropTypes.string,
  subtitleColorClass: PropTypes.string,
  titleText: PropTypes.string,
};

export default SectionTitle;
